import { createContext, useContext } from "react";
import { Case } from "../cases.types";
import { CasesQuery } from "../cases.query";

export type CaseContextType = {
  data: Case | undefined;
  isLoading: boolean;
  isError: boolean;
};

const CaseContext = createContext<CaseContextType | undefined>(undefined);

export const CaseProvider: React.FC<{
  children: React.ReactNode;
  case_id: number;
}> = ({ children, case_id }) => {
  const { data, isLoading, isError } = CasesQuery.useGetCases({
    case_id,
  });

  const caseData = data?.data?.[0] || undefined;

  const contextValue: CaseContextType = {
    data: caseData,
    isLoading,
    isError,
  };

  return (
    <CaseContext.Provider value={contextValue}>{children}</CaseContext.Provider>
  );
};

export const useCaseContext = () => {
  const context = useContext(CaseContext);
  return context;
};
